import { withTranslate } from '../../decorators/withTranslate';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassNameGenerator } from 'helper/className';
import HeaderTitle from './HeaderTitle';
import UserInfo from './UserInfo';
import ToggleMenu from '../layout/ToggleMenu';
import { AppLanguageSelector } from '../../helper';
import UserInfoDropdown from './UserInfoDropdown';
import BlockWithAvatar from '../BlockWithAvatar/BlockWithAvatar';
import Logout from './Logout';
import * as BaseRouteWrapper from '../../routes/baseRouteWrapper';
import { Link } from 'react-router';

const Header = ({ className, children, headerData, title, t, currentAccount }) => (
  <header className={classNames(className, Header.className)}>
    <div className={Header.getClassName('logo-group')}>
      <HeaderTitle className={Header.getClassName('title')}>{title}</HeaderTitle>
      <BlockWithAvatar className={Header.getClassName('avatar-block')} src={currentAccount.portraitUrl} avatarSize={32}>
        <UserInfo className={Header.getClassName('account')} account={currentAccount} />
      </BlockWithAvatar>
      <Link
        display-if={currentAccount.isActAs}
        to={BaseRouteWrapper.getLogout(headerData.module, true)}
        className={classNames('btn-action', Header.getClassName('switch-back__main'))}
      >
        {t('Back to my account')}
      </Link>
    </div>
    <div className={Header.getClassName('content')}>
      {children}
    </div>
    <div className={Header.getClassName('menu')}>
      <UserInfoDropdown account={currentAccount} className={Header.getClassName('account-dropdown')}>
        <UserInfo account={currentAccount} className={Header.getClassName('account')} />
        <Link
          display-if={currentAccount.isActAs}
          to={BaseRouteWrapper.getLogout(headerData.module, true)}
          className={classNames('btn-action', Header.getClassName('switch-back__submenu'))}
        >
          {t('Back to my account')}
        </Link>
        <Link className={Header.getClassName('logout')} to={BaseRouteWrapper.getLogout(headerData.module)}>
          <i className='fa fa-sign-out' />
          {t('Sign Out')}
        </Link>
      </UserInfoDropdown>
      <AppLanguageSelector />
      <Logout className={Header.getClassName('logout-button')} headerData={headerData} />
      <ToggleMenu className={Header.getClassName('toggle-menu')} />
    </div>
  </header>
);

Header.className = 'header';
Header.getClassName = getClassNameGenerator(Header.className);

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  headerData: PropTypes.any,
  title: PropTypes.string,
  currentAccount: PropTypes.object,
  t: PropTypes.func
};

Header.defaultProps = {

};

export default withTranslate()(Header);

